import type { ComponentProps } from "react";

import { cn } from "./cn";

const field =
  "w-full min-w-0 rounded-md border border-input bg-card px-3 text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-destructive";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return <input className={cn(field, "min-h-11 py-2", className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return <textarea className={cn(field, "min-h-24 resize-y py-2", className)} {...props} />;
}

/** A native select styled like the inputs (works everywhere, including phones and screen readers). */
export function NativeSelect({ className, ...props }: ComponentProps<"select">) {
  return <select className={cn(field, "min-h-11 py-2 pr-8", className)} {...props} />;
}

export function Label({ className, ...props }: ComponentProps<"label">) {
  return <label className={cn("flex flex-col gap-1.5 text-[0.86rem] font-medium text-muted-foreground", className)} {...props} />;
}
